export var BillingCycle;
(function (BillingCycle) {
    BillingCycle["MONTHLY"] = "MONTHLY";
    BillingCycle["QUARTERLY"] = "QUARTERLY";
    BillingCycle["SEMI_ANNUAL"] = "SEMI_ANNUAL";
    BillingCycle["ANNUALLY"] = "ANNUALLY";
})(BillingCycle || (BillingCycle = {}));
export var Currency;
(function (Currency) {
    Currency["BRL"] = "BRL";
    Currency["USD"] = "USD";
})(Currency || (Currency = {}));
// Helper types for billing cycle display
export const BILLING_CYCLE_LABELS = {
    [BillingCycle.MONTHLY]: "Monthly",
    [BillingCycle.QUARTERLY]: "Quarterly",
    [BillingCycle.SEMI_ANNUAL]: "Semi-Annual",
    [BillingCycle.ANNUALLY]: "Annually",
};
export const BILLING_CYCLE_MONTHS = {
    [BillingCycle.MONTHLY]: 1,
    [BillingCycle.QUARTERLY]: 3,
    [BillingCycle.SEMI_ANNUAL]: 6,
    [BillingCycle.ANNUALLY]: 12,
};
// Helper types for currency display
export const CURRENCY_LABELS = {
    [Currency.BRL]: "Brazilian Real (BRL)",
    [Currency.USD]: "US Dollar (USD)",
};
//# sourceMappingURL=CustomerPlan.js.map